import { UserRole } from 'context/user/userContext/UserContext.types';

export const userData = {
  [UserRole.Manufacturer]: {
    firstName: 'Manufacturer',
    lastName: 'X',
    email: 'bats@madeinchina.com',
    origin: 'Belgium',
  },
  [UserRole.Owner]: {
    firstName: 'Bart',
    lastName: 'Coelus',
    email: 'bart.coelus@fluvius.com',
  },
  [UserRole.Installer]: {
    firstName: 'Installer',
    lastName: 'X',
    email: 'handy.man@weinstallitall.com',
  },
  [UserRole.Verifier]: {
    firstName: 'Verifier',
    lastName: 'X',
    email: 'igo.forquality@123check.io',
  },
  [UserRole.GoverningBody]: {
    firstName: 'GoverningBody',
    lastName: 'X',
    email: 'bats@madeinchina.com',
    origin: 'Belgium',
  },
};
